import React, { useContext } from "react";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import Card from "~/components/parts/Card";
import { cn } from "~/utils";
import { SubscriptionContext } from ".";

dayjs.extend(advancedFormat);

const Status = () => {
  const { subscription = {} } = useContext(SubscriptionContext);
  let { expiry, status } = subscription;

  const formattedExpiry = expiry
    ? dayjs(expiry * 1000).format("Do MMMM YYYY")
    : "";

  const message = {
    ACTIVE: (
      <span>
        Your subscription is <b>active</b> until {formattedExpiry}
      </span>
    ),
    EXPIRED: (
      <span>
        Your subscription <b>expired</b> on {formattedExpiry}
      </span>
    ),
  }[status] ?? <span>Your school does not currently have a subscription.</span>;

  return (
    <Card
      className={cn(
        status === "ACTIVE" && "border-l-green-400",
        status === "EXPIRED" && "border-l-red-400",
      )}
      title="Status"
    >
      <p className="m-0 text-slate-700">{message}</p>
    </Card>
  );
};

export default Status;
